/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Agents_Role_TriggeredInputs */



/**
* | output |
* | --- |
* | "Started by new rows" |
*
* @param {Datasets_Agents_Role_TriggeredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_agents_role_triggered = /** @type {((inputs?: Datasets_Agents_Role_TriggeredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Agents_Role_TriggeredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Startet bei neuen Zeilen")
	return /** @type {LocalizedString} */ ("Started by new rows")
});